<template>
  <div>
    <v-row class="personal-info-content">
      <v-col cols="12">
        <div class="d-block d-md-flex justify-space-between w-100 align-center">
          <h2 class="group-label text-left flex">Addresses</h2>
          <div class="text-left text-md-left">
            <a @click="add"> Add Address </a>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-row class="p-0 m-0">
          <v-col class="py-0 d-flex justify-space-between">
            <div class="flex">
              <div
                v-for="address in userAddresses"
                :key="address.id"
                class="mt-3 mt-md-0"
              >
                <div
                  class="d-block d-md-flex align-center justify-space-between"
                >
                  <div class="flex text-left font-15 w-70">
                    {{ address | formattedAddress }}
                  </div>
                  <div class="text-right">
                    <v-chip
                      class="ma-2 mr-4 white--text"
                      small
                      :color="
                        address.approved == 1
                          ? '#23A0A0'
                          : address.approved == 2
                          ? '#FF7777'
                          : '#C03737'
                      "
                    >
                      {{
                        address.approved == 1
                          ? "Approved"
                          : address.approved == 2
                          ? "Pending"
                          : "Unapproved"
                      }}
                    </v-chip>

                    <v-btn
                      icon
                      small
                      @click="openUserAddressEditModal(address)"
                    >
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn icon small @click="deleteAndRefresh(address.id)">
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
                <v-divider class="d-block d-md-none"></v-divider>
              </div>
            </div>
            <!-- <v-radio-group @change="changeActive" :value="active" class="mt-0">
              <template v-for="address in addresses">
                <v-radio
                  :key="address.id"
                  :label="address.label"
                  :value="address.id"
                  v-if="address.label !== ''"
                ></v-radio>
              </template>
            </v-radio-group> -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="showEditModal" width="800">
      <v-form ref="addressEditForm" @submit.prevent="editAddress">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Update Address</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    v-model="address.address"
                    :rules="addressRules"
                    label="Address"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    v-model="address.city"
                    :rules="cityRules"
                    label="City"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    v-model="address.postcode"
                    :rules="postcodeRules"
                    label="Postcode"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6" @click.stop>
                  <v-select
                    outlined
                    v-model="address.countryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    item-text="name"
                    item-value="id"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    v-model="address.aptNo"
                    :rules="aptNoRules"
                    label="Building No"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    v-model="address.state"
                    :rules="stateRules"
                    label="State"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showAddModal" width="800">
      <v-form ref="addressCreateForm" @submit.prevent="createAddress">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Create Address</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    v-model="address.address"
                    :rules="addressRules"
                    label="Address"
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    v-model="address.city"
                    :rules="cityRules"
                    label="City"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    v-model="address.postcode"
                    :rules="postcodeRules"
                    label="Postcode"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6" @click.stop>
                  <v-select
                    outlined
                    v-model="address.countryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    value
                    item-text="name"
                    item-value="id"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    v-model="address.aptNo"
                    :rules="aptNoRules"
                    label="Building No"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    v-model="address.state"
                    :rules="stateRules"
                    label="State"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
export default {
  props: {
    payload: {
      from: 0,
      to: 10,
      userId: null
    }
  },
  mixins: [Helpers],
  filters: {
    formattedAddress: function(address) {
      let formatted = `${address.aptNo} ${address.address}, ${address.city}, ${address.postcode}, ${address.country.name}`;
      return formatted.length > 75
        ? `${formatted.substring(0, 75)}...`
        : formatted;
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      address: {},
      showAddModal: false,
      showEditModal: false,
      addressRules: [
        v => !!v || "Address is required",
        v => (v && v.length >= 4) || "Address must be at least 4 characters",
        v =>
          (v && v.length <= 100) ||
          "Address must be less than than 100 characters"
      ],
      cityRules: [
        v => !!v || "City is required",
        v => (v && v.length >= 3) || "City must be at least 3 characters",
        v =>
          (v && v.length <= 35) || "City must be less than than 35 characters"
      ],
      postcodeRules: [
        v => !!v || "Postcode is required",
        v => (v && v.length >= 3) || "Postcode must be at least 3 characters",
        v =>
          (v && v.length <= 10) ||
          "Postcode must be less than than 10 characters"
      ],
      countryRules: [v => !!v || "Country is required"],
      aptNoRules: [v => !!v || "Apt no is required"],
      stateRules: [
        v => !!v || "State is required",
        v => (v && v.length >= 3) || "State must be at least 3 characters",
        v =>
          (v && v.length <= 25) || "State must be less than than 25 characters"
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Address",
          align: "left",
          sortable: false,
          value: "address"
        },
        {
          text: "Building No",
          align: "left",
          value: "aptNo",
          sortable: false
        },
        {
          text: "State",
          align: "left",
          sortable: false,
          value: "state"
        },
        {
          text: "Post Code",
          align: "left",
          sortable: false,
          value: "postcode"
        },
        {
          text: "Country",
          align: "left",
          sortable: false,
          value: "country"
        },
        {
          text: "City",
          align: "left",
          value: "city"
        },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    userAddresses() {
      return this.$store.state.useraddresses.userAddresses;
    },
    totalItems() {
      return this.$store.state.useraddresses.total;
    },
    countries() {
      return this.$store.state.countries.countries;
    }
  },
  created() {
    this.getUserAddresses(this.payload);
    this.$store.dispatch("countries/LOAD_COUNTRIES", {
      from: 0,
      to: 0
    });
  },
  methods: {
    openUserAddressEditModal(address) {
      this.address = address;
      this.showEditModal = true;
    },
    filterName(value) {
      this.payload.name = value;
      this.getUserAddresses(this.payload);
    },
    filterApproved(value) {
      this.payload.approved = value;
      this.getUserAddresses(this.payload);
    },
    getUserAddresses(payload) {
      this.loading = true;
      console.log(payload);
      this.$store
        .dispatch("useraddresses/LOAD_USER_ADDRESSES", payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      this.payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      this.payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getUserAddresses(this.payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroyAddress(id);
      if (res) {
        this.getUserAddresses(this.payload);
      }
    },
    async createAddress() {
      if (this.$refs.addressCreateForm.validate()) {
        this.showAddModal = false;
        this.$swal({
          title: "Creating address",
          html: "This will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("useraddresses/CREATE_USER_ADDRESS", {
          userId: this.payload.userId,
          address: this.address
        });
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Address created successfully",
          icon: "info"
        });
        this.getUserAddresses(this.payload);
      }
    },
    async destroyAddress(id) {
      let { value } = await this.$swal.fire({
        title: "Delete Address",
        html: "Are you sure you want to delete this Address ",
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No"
      });
      if (value) {
        this.$swal({
          title: "Deleting Address ...",
          html: "this may only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("useraddresses/DESTROY_USER_ADDRESS", {
          userId: this.payload.userId,
          id: id
        });
        this.$swal({
          title: "Success",
          html: "Address has been deleted",
          icon: "info"
        });
        return true;
      }
      return false;
    },
    add() {
      this.showAddModal = true;
    },
    async editAddress() {
      if (this.$refs.addressEditForm.validate()) {
        this.showEditModal = false;
        this.$swal({
          title: "Updating address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("useraddresses/UPDATE_USER_ADDRESS", {
          userId: this.payload.userId,
          address: this.address
        });
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Address updated successfully",
          icon: "info"
        });
        this.$refs.addressEditForm.resetValidation();
      }
    },
    async save(address, index) {
      if (this.$refs[index + "-form"][0].validate()) {
        this.$swal({
          title:
            address.id === undefined
              ? "Creating address..."
              : "Updating address",
          html: "this will only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/SAVE_ADDRESS", address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html:
            address.id !== undefined
              ? "Address updated successfully"
              : "Address created successfully",
          icon: "info"
        });
      }
    }
  }
};
</script>
<style lang="scss">
#users {
  .filters {
    .v-text-field__details {
      display: none;
    }
  }
}
.personal-info {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
  .row {
    &.personal-info-content {
      background-color: white;
      border-radius: 10px;
      @media all and (max-width: 676px) {
        margin: 10px 0 0 0;
        padding: 8px 12px;
        border: none;
      }
      border: 1px solid var(--v-appDarkGrey-base);
      h2 {
        font-family: Gotham-Book;
        font-size: 16px;
      }
      > .col {
        padding: 0;
        > .row {
          > .col-12 {
            @media all and (max-width: 676px) {
              padding: 8px 12px;
            }
            .v-input:not(.v-input--checkbox) {
              border: 1px solid #aaaaaa;
              @media all and (max-width: 676px) {
                border: none;
                .v-input__slot {
                  background: #f2f2f2 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
